import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-edit-footer-section',
  templateUrl: './edit-footer-section.component.html',
  styleUrls: ['./edit-footer-section.component.scss']
})
export class EditFooterSectionComponent implements OnInit {
  @Input() footerSectionInfo: any;
  copyOfFooterSection: any;

  constructor(
    private activeModal: NgbActiveModal,
  ) {
  }

  ngOnInit(): void {
    this.copyOfFooterSection = {...this.footerSectionInfo};
  }


  sendData(): any {
    // const arrToSend = this.copyOfFooterSection.detail.map( x => {
    //   return {
    //     id: x.id,
    //     item: x.name,
    //     url: x.url,
    //     orderId: x.orderId
    //   };
    // });
    // const dataToSend = {
    //   id: this.copyOfFooterSection.id,
    //   name: this.copyOfFooterSection.name,
    //   footerItem: arrToSend
    // };
    const dataToSend = {...this.footerSectionInfo};
    //
    this.activeModal.close(dataToSend);
  }

  createLinkFields() {
    this.footerSectionInfo.footerItem.push({
      id: 0,
      name: '',
      url: '',
      orderId: this.footerSectionInfo.footerItem.length + 1,
    });
  }


  deleteLinkField(i: number): any {
    if (this.footerSectionInfo.footerItem.length > 1) {
      this.footerSectionInfo.footerItem.splice(i, 1);
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'No puedes eliminar el primer link!',
      });
    }
  }

  validateEmptyFields(): any {
    if (!this.footerSectionInfo.name ||
      this.footerSectionInfo.footerItem.filter(x => !x.item).length ||
      this.footerSectionInfo.footerItem.filter(x => !x.url).length
    ) {
      return false;
    } else {
      return true;
    }
  }
}
